import BaseDropSelection from "%/dynamic-component-editor/classes/base-drop-selection";
import ResumeStoryCardId from "%/dynamic-component-editor/options/resume-story-card-id";
import ResumeEmptyCardId from "%/dynamic-component-editor/options/resume-empty-card-id";

export const RESUME_CARD_ELEMENT_TYPE = "ResumeCard";

export default class ResumeCardSelection extends BaseDropSelection {
  static modalTitle = "Select Resume Cards";
  static promptText = "Pick the card to show when this reader has a story in progress, "
    + "and the card to show when they have nothing to resume.";
  static createItemLabel = "Create a new component";
  static defaultNewItemName = "New Component";
  static createPlaceholder = "Name your new component";
  static pickExistingLabel = "Choose an existing component instead";

  static rows() {
    return [
      {
        optionKey: ResumeStoryCardId.optionKey,
        rowLabel: "With a story to resume",
        placeholder: "Select a component",
        optional: false,
      },
      {
        optionKey: ResumeEmptyCardId.optionKey,
        rowLabel: "Nothing to resume",
        placeholder: "Select a component (optional)",
        optional: true,
      },
    ];
  }

  static candidates(store) {
    return store.referencedComponentCandidates
        .map(candidate => ({ label: candidate.name, value: candidate.id }));
  }

  static createCandidate(store, name) {
    return store.createComponentForDropSelection(name);
  }
}

BaseDropSelection.register(RESUME_CARD_ELEMENT_TYPE, ResumeCardSelection);
